// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__18UVD","rootSuccess":"CompleteLink_rootSuccess__19fMe","rootFailure":"CompleteLink_rootFailure__33NGj","isDisabled":"CompleteLink_isDisabled__1ZwOf"};